module.exports = __webpack_public_path__ + "static/media/glass2.6584b6d0.svg";